export default __webpack_public_path__ + "static/media/treatmentTrackers.bcfef1aa.png";